export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=402bd2a8b07c6ef746e13b85dbaaeda2f2308170f7&name=revalidateCommunity!'